import { useTypedQuery } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

export const useCarBrandsQuery = () =>
  useTypedQuery({
    queryKey: AppointmentDetailsKeys.carBrands,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, {}, baseUrl)).data.brands ?? []
  });
